import {observer} from "mobx-react";
import TranslationScope from "../../../../../../translation/translation-scope";
import useTranslation from "../../../../../../translation/hooks/translation-hook";
import {useEffect} from "react";
import usePage from "../../../../../../components/layouts/base-page-layout/page-hook";
import AddressSlipTranslationsEditor from "./address-slip-translations-editor";

const AddressSlipTranslationsEditorPage: React.FC = observer(() => {
    const {setSubTitles, setInstruction} = usePage();

    useEffect(() => {
        setSubTitles(['Return Methods', 'Address Slip']);
        setInstruction(undefined);
    }, [setSubTitles, setInstruction]);

    const {selectedLocale} = useTranslation();

    return (
        <TranslationScope scope="address-slip" locale={selectedLocale}>
            <AddressSlipTranslationsEditor/>
        </TranslationScope>
    );
});

export default AddressSlipTranslationsEditorPage;